import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import { getOmniState } from './helpers';

import { LenderStatus } from '../constants';

interface OmniStatusContentHook {
  state: LenderStatus;
  isLoading: boolean;
}

export default function useOmniStatusContent(): OmniStatusContentHook {
  const { job, credit, deposit, isLoading } = useStatusContext();

  const state = useMemo((): LenderStatus => {
    if (isLoading || !job || !credit) return 'loading';
    return getOmniState(job, credit, deposit);
  }, [isLoading, job, credit, deposit]);

  return {
    state,
    isLoading,
  };
}
